import { useTranslation } from '@numistic/i18n'
import { createRoute, Link, Outlet, redirect } from '@tanstack/react-router'

import { requireSession } from '../../lib/guards.js'
import { rootRoute } from '../root.js'

export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  beforeLoad: ({ context, location }) => requireSession(context, location),
  component: SettingsLayout,
})

/** /settings → первая вкладка. */
export const settingsIndexRoute = createRoute({
  getParentRoute: () => settingsRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/settings/profile' })
  },
})

const TABS = [
  { to: '/settings/profile', key: 'profile' },
  { to: '/settings/collections', key: 'collections' },
  { to: '/settings/locations', key: 'locations' },
  { to: '/settings/tags', key: 'tags' },
  { to: '/settings/counterparties', key: 'counterparties' },
  { to: '/settings/devices', key: 'devices' },
  { to: '/settings/data', key: 'data' },
] as const

/**
 * Раздел настроек: профиль, коллекции, места хранения, теги и подборки, устройства, данные.
 * На широком экране вкладки слева, на телефоне — прокручиваемой полосой сверху.
 */
function SettingsLayout() {
  const { t } = useTranslation()
  return (
    <div className="grid gap-6">
      <h1 className="text-2xl font-semibold">{t('settings.title')}</h1>
      <div className="grid items-start gap-6 lg:grid-cols-[13rem_minmax(0,1fr)]">
        <nav
          aria-label={t('settings.title')}
          className="-mx-4 flex gap-1 overflow-x-auto border-b px-4 pb-2 lg:sticky lg:top-4 lg:mx-0 lg:grid lg:border-b-0 lg:px-0 lg:pb-0"
        >
          {TABS.map((tab) => (
            <Link
              key={tab.key}
              to={tab.to}
              search={{}}
              className="shrink-0 rounded-md px-3 py-2 text-sm whitespace-nowrap text-muted-foreground transition-colors hover:bg-accent hover:text-foreground [&.active]:bg-accent [&.active]:font-medium [&.active]:text-foreground"
            >
              {t(`settings.tabs.${tab.key}`)}
            </Link>
          ))}
        </nav>
        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
